<template>
    <b-card title="General information">
        <b-row>
            <b-col md="8">
                <b-form-group label="Name" label-for="import-manifest-name">
                    <b-form-input
                        id="import-manifest-name"
                        :value="value.name"
                        :disabled="disabled"
                        maxlength="255"
                        placeholder="Manifest name"
                        @input="update('name', $event)"
                    />
                </b-form-group>

                <b-form-group label="Description" label-for="import-manifest-description">
                    <b-form-textarea
                        id="import-manifest-description"
                        :value="value.description"
                        :disabled="disabled"
                        rows="4"
                        max-rows="8"
                        placeholder="Describe when this manifest should be used"
                        @input="update('description', $event)"
                    />
                </b-form-group>
            </b-col>

            <b-col md="4">
                <b-form-group label="Import type">
                    <b-form-select
                        :value="value.manifestType"
                        :options="importTypeOptions"
                        :disabled="disabled || !isNew"
                        @input="selectImportType"
                    />
                </b-form-group>

                <b-form-group label="Manifest type">
                    <b-form-input :value="value.manifestType" disabled />
                </b-form-group>

                <b-form-group label="Owner context">
                    <b-form-input :value="value.ownerContext" disabled />
                </b-form-group>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import {
    BCard,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BRow,
} from 'bootstrap-vue'
import {
    getImportManifestContext,
    IMPORT_MANIFEST_CONTEXTS,
} from '../manifestContexts'

export default {
    components: {
        BCard,
        BCol,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BFormTextarea,
        BRow,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isNew() {
            return !this.value.id
        },
        importTypeOptions() {
            return IMPORT_MANIFEST_CONTEXTS.map(context => ({
                value: context.manifestType,
                text: context.label,
            }))
        },
    },
    methods: {
        update(property, propertyValue) {
            this.$emit('input', {
                ...this.value,
                [property]: propertyValue,
            })
        },
        selectImportType(manifestType) {
            const context = getImportManifestContext(manifestType)
            if (!context || !this.isNew) {
                return
            }

            this.$emit('input', {
                ...this.value,
                manifestType: context.manifestType,
                ownerContext: context.ownerContext,
            })
        },
    },
}
</script>
